/*
Generated time: May 22, 2025 08:21
This file was created by the app developer. Feel free to contact the original developer with any questions. It was minified (compressed) by AVADA. AVADA do NOT own this script.
*/
document.addEventListener('DOMContentLoaded', function () {
  let n
  function r() {
    ;(e = 1), (t = 9)
    var t = Math.floor(Math.random() * (t - e)) + e,
      e = new Date()
    n = e.setHours(e.getHours() + t)
  }
  let t
  r(),
    t && clearInterval(t),
    (t = setInterval(function () {
      var t = (() => {
        var t = new Date()
        let e = new Date(n).getTime() - t.getTime()
        e < 0 && (r(), (e = 0))
        var t = Math.floor((e / 36e5) % 24),
          o = Math.floor((e / 6e4) % 60),
          s = Math.floor((e / 1e3) % 60)
        return {
          hour: 10 <= t ? t : '0' + t,
          minute: 10 <= o ? o : '0' + o,
          second: 10 <= s ? s : '0' + s,
        }
      })()
      $('.sp_top_cut_down .sp_left_view .sp_hour').html(t.hour),
        $('.sp_top_cut_down .sp_left_view .sp_minute').html(t.minute),
        $('.sp_top_cut_down .sp_left_view .sp_second').html(t.second)
    }, 1e3)),
    new Swiper('.sp-swiper-btn', {
      autoplay: !0,
      autoplay: { disableOnInteraction: !1, reverseDirection: !0, delay: 5e3 },
      loop: !0,
    })
  let e = new Swiper('#swiper-p1', { speed: 1, spaceBetween: 20 }),
    o = [
      'https://cdn.shopify.com/s/files/1/0580/9963/0214/files/202504162-p1.png',
      'https://cdn.shopify.com/s/files/1/0580/9963/0214/files/202504162-p2.png',
      'https://cdn.shopify.com/s/files/1/0580/9963/0214/files/202504162-p3.png',
      'https://cdn.shopify.com/s/files/1/0580/9963/0214/files/202504162-p1-2.png',
      'https://cdn.shopify.com/s/files/1/0580/9963/0214/files/202504162-p2-2.png',
      'https://cdn.shopify.com/s/files/1/0580/9963/0214/files/202504162-p3-2.png',
      'https://cdn.shopify.com/s/files/1/0580/9963/0214/files/202504162-b1.png',
      'https://cdn.shopify.com/s/files/1/0580/9963/0214/files/202504162-b2.png',
      'https://cdn.shopify.com/s/files/1/0580/9963/0214/files/202504162-b3.png',
      'https://cdn.shopify.com/s/files/1/0580/9963/0214/files/202504162-b4.png',
      'https://cdn.shopify.com/s/files/1/0580/9963/0214/files/202504162-b5.png',
    ]
  var s = navigator.userAgent || navigator.vendor || window.opera,
    a = /android/i.test(s),
    c = /iPad|iPhone|iPod/.test(s) && !window.MSStream,
    s = !a && !c && !/Iron/.test(s)
  a
    ? console.log('Android')
    : c
    ? console.log('iOS')
    : s
    ? console.log('PC')
    : $('.sp_system').css('letter-spacing', '-4px'),
    $(function () {
      $('#root').css('zoom', 'normal')
      var t,
        e = document.body.clientWidth / 1080
      $('#root').css('zoom', e),
        window.addEventListener('resize', function () {
          t && clearTimeout(t),
            (t = setTimeout(function () {
              $('#root').css('zoom', 'normal')
              var t = document.body.clientWidth / 1080
              $('#root').css('zoom', t)
            }, 100))
        })
    })
  {
    a = document.querySelectorAll('.lazy-load')
    let o = new IntersectionObserver(
      function (t, e) {
        t.forEach(function (t) {
          var e
          t.isIntersecting &&
            ((e = (t = t.target).getAttribute('data-src')),
            (t.src = e),
            o.unobserve(t))
        })
      },
      { rootMargin: '0px 0px 1300px 0px', threshold: 0 }
    )
    a.forEach(function (t) {
      o.observe(t)
    })
  }
  ;(a = o),
    Array.isArray(a[0])
      ? a.forEach(t => {
          t.forEach(t => {
            new Image().src = t
          })
        })
      : a.forEach(t => {
          new Image().src = t
        }),
    document.querySelectorAll('a[href^="#shopping"]').forEach(function (t) {
      t.addEventListener('click', function (t) {
        t.preventDefault()
        var t = document.getElementById('shopping').offsetTop,
          e = $('.time-part').height() + $('.sp-header-top').height()
        window.scroll({
          top: t * $('div#root').css('zoom') - e * $('div#root').css('zoom'),
          behavior: 'smooth',
        })
      })
    })
  let p = window.product
  function l() {
    let e = $('#sp-color div.active').attr('data-val'),
      o = $('#sp-num div.active').attr('data-val'),
      a = $('#sp-adds div.active').attr('data-val')
    return p.filter(t => t.option1 == e && t.option2 == o && t.option3 == a)[0]
  }
  function d() {
    var t = $('#calcNumber').val(),
      e = ((l().price * t) / 100).toFixed(2),
      t = ((l().compare_at_price * t) / 100).toFixed(2),
      e =
        ($('#sp_price1').html(e),
        $('#sp_price2').html(t),
        100 - Math.ceil((l().price / l().compare_at_price) * 100))
    $('.product-part .price-group .sp-row span').html(e)
  }
  $('.sp-btn-style').click(function () {
    var t = $('#calcNumber').val()
    window.location.href = '/cart/' + l().id + ':' + t
  }),
    $('.sp-reduce').click(function () {
      var t = $(this).siblings('input')[0],
        e = Number(t.value) - 1
      0 < e && (t.value = e), d()
    }),
    $('.sp-add').click(function () {
      var t = $(this).siblings('input')[0],
        e = Number(t.value) + 1
      ;(t.value = e), d()
    }),
    $(function () {
      $('.sp-option').click(function () {
        $(this).siblings().removeClass('active'), $(this).addClass('active')
        var t =
          $('#sp-color .sp-option.active').index() +
          3 * $('#sp-num .sp-option.active').index() +
          9 * $('#sp-adds .sp-option.active').index()
        e.slideTo(t), d()
      }),
        $('.cart-btn').click(function () {
          $(this).children('img').addClass('on'),
            $('.sp-header-top .sp-cart .num').show(),
            setTimeout(function () {
              $('.cart-btn').children('img').removeClass('on')
            }, 500),
            $('.sp-header-top .sp-cart').addClass('on'),
            setTimeout(function () {
              $('.sp-header-top .sp-cart').removeClass('on')
            }, 500)
        })
      $('.product-part .cart-btn').click(function () {
        var t = { id: l().id, quantity: $('#calcNumber').val() },
          t =
            ($.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data: t,
              success: function () {
                $.getJSON(window.Shopify.routes.root + 'cart.js', function (t) {
                  $('#cardNum').html(t.item_count)
                })
              },
              dataType: 'json',
            }),
            $('.product-part .sp-swiper .swiper-slide-active .sp-img')),
          e = t[0].cloneNode(!0),
          e =
            (e.classList.add('sp_clone'),
            $('.product-part').append(e),
            $('.sp_clone').css({
              width: t[0].width,
              height: t[0].height,
              position: 'fixed',
              top: t[0].offsetTop,
              left: t.offset().left,
              'z-index': '99',
            }),
            $('.sp-cart'))
        $('.sp_clone').animate(
          {
            top: e[0].offsetTop + $('.time-part').height(),
            left: e[0].offsetLeft + e.width() / 2,
            width: 50,
            height: 50,
            opacity: 0.4,
          },
          500,
          'linear',
          function () {
            $(this).animate(
              { width: 0, height: 0, opacity: 0 },
              0,
              function () {
                $(this).detach()
              }
            )
          }
        )
      })
    })
  var h = 180 / Math.sin(Math.PI / 12)
  carouselSwiper = new Swiper('#carousel .swiper', {
    watchSlidesProgress: !0,
    slidesPerView: 'auto',
    centeredSlides: !1,
    loop: !0,
    loopedSlides: 3,
    grabCursor: !0,
    autoplay: { delay: 0, stopOnLastSlide: !1, disableOnInteraction: !1 },
    freeMode: !0,
    speed: 5e3,
    on: {
      progress: function (t, e) {
        for (i = 0; i < this.slides.length; i++) {
          var o = this.slides.eq(i),
            s = this.slides[i].progress,
            n =
              (s + 1) *
                (90 - (360 * Math.cos((s + 1) * (1 / 6) * Math.PI) * 1.2) / 4) +
              'px',
            r = 30 * (s + 1),
            s = h - Math.cos((s + 1) * (1 / 6) * Math.PI) * h - 150 + 'px'
          o.transform(
            'translateX(' + n + ') translateZ(' + s + ') rotateY(' + r + 'deg)'
          )
        }
      },
      setTransition: function (t, e) {
        for (var o = 0; o < this.slides.length; o++)
          this.slides.eq(o).transition(e)
      },
    },
  })
})
